export default "__VITE_ASSET__8KByd7W0oH8zGe1MvrBFUw__ 480w, __VITE_ASSET__ShLFqVI8xue0ZXbFLAmM8g__ 768w, __VITE_ASSET__3Lrf7vA$GngskD3e2_Wsaw__ 1200w";